// removed by extract-text-webpack-plugin
module.exports = {"resume-form":"resume-form","resume-form__top":"resume-form__top","form-group__wrap":"form-group__wrap","resume-form__bottom":"resume-form__bottom","resume-form__comment":"resume-form__comment","resume-file":"resume-file","error":"error","error-file":"error-file","resume-file__field":"resume-file__field","resume-file__empty":"resume-file__empty","off":"off","svg-icon":"svg-icon","error_file":"error_file"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_resume.scss
// module id = 283
// module chunks = 0